import apiHelpers from '@/utils/api'
import { AxiosPromise } from 'axios'
import { AlrContainer } from '@/models/response/AlrContainer'
import { AloDbGlider, IAloDbGliderConstParam } from '@/models/alodb/AloDbGlider'
import { ApiResultCode } from '@/models/response/AlrBase'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { IrisrawModNextSurfacingDo } from '@/models/iris/IrisrawModNextSurfacingDo';
import { IrisrawModFileTransfer } from '@/models/iris/IrisrawModFileTransfer';
import { IrisrawModSingleWayPoint } from '@/models/iris/IrisrawModSingleWayPoint';
import { IrisConfigContainer } from '@/models/iris/IrisConfigContainer';
import { INextSurfacingDoConfig } from '@/models/iris/nextSurfacing/INextSurfacingDoConfig';
import { IFileTransfertConfig } from '@/models/iris/fileTransfert/IFileTransfertConfig';
import { ISingleWayPointConfig } from '@/models/iris/singleWayPoint/ISingleWayPointConfig';
import { IrisrawModExpectedNMEA } from '@/models/iris/IrisrawModExpectedNMEA';
import { IExpectedNMEAConfig } from '@/models/iris/expectedNMEA/IExpectedNMEAConfig';
import { IrisrawGliderState } from '@/models/iris/IrisrawGliderState'
import { IrisrawModFtp } from '@/models/iris/IrisrawModFtp'
import { IFtpConfig } from '@/models/iris/ftp/IFtpConfig'
import { IrisrawModRsync } from '@/models/iris/IrisrawModRsync'
import { IRsyncConfig } from '@/models/iris/rsync/IRsyncConfig'

/*apiHelpers.addMocks({
  'api/admin/glider': {
    'GET':() => {
      return  {
        resultCode:ApiResultCode.Ok,
        datStr:new Date(),
        data: {
            gliders: [
            new AloDbGlider({              
              GLI_ID:1,
              GLI_KEY:"Gli1",
              GLI_LIBELLE:"Gli1",
              GLI_DATFAB:new Date().toUTCString(),
              detailLoaded:true
            } as IAloDbGliderConstParam)
          ]
        },
        dataTypeName: 'AloDbGliderArray'
      } as AlrContainer<AloDbGliderArray>
    }
  }
})*/


export default {  
  getGliders(): AxiosPromise<AlrContainer<AloBaseArray<AloDbGlider>>> {
    
    return apiHelpers.apiCall({ 
      url: 'api/admin/glider', 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloBaseArray<AloDbGlider>>(JSON.parse(data),AloDbGlider.createAloDbGliderArray)
      }]
    })
  },
  getGlider(id:number):AxiosPromise<AlrContainer<AloDbGlider>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/glider/${id}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<AloDbGlider>(JSON.parse(data),AloDbGlider.createAloDbGliderWithDetail)
      }]
    })
  },
  sendIrisCommand({gliId,command}:{gliId:number,command:string}) {    
    return apiHelpers.apiCall({ 
      url: `api/iris/glidercmd/send/${gliId}/${encodeURIComponent(command)}`, 
      method: 'GET'
    })
  },
  postIrisCommand({gliId,command}:{gliId:number,command:string}) {    
    return apiHelpers.apiCall({ 
      url: `api/iris/glidercmd/send/${gliId}`, 
      method: 'POST',
      data:{
        command
      }
    })
  },
  saveGlider(glider:AloDbGlider):AxiosPromise<AlrContainer<AloDbGlider>> {
    if(glider.GLI_ID && glider.GLI_ID > 0) {
      return  apiHelpers.apiCall({ 
        url: `api/admin/glider/${glider.GLI_ID}`, 
        method: 'PUT',
        data: glider,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbGlider>(JSON.parse(data),AloDbGlider.createAloDbGliderWithDetail)
        }]
      })    
    }
    else{
      return  apiHelpers.apiCall({ 
        url: `api/admin/glider`, 
        method: 'POST',
        data: glider,
        transformResponse: [function (data:string) {          
          return new AlrContainer<AloDbGlider>(JSON.parse(data),AloDbGlider.createAloDbGliderWithDetail)
        }]
      })    
    }        
  },
  deleteGlider(id:number):AxiosPromise<AlrContainer<AloDbGlider>> {
    return  apiHelpers.apiCall({ 
      url: `api/admin/glider/${id}`, 
      method: 'DELETE',
      transformResponse: [function (data:string) {
        return new AlrContainer<any>(JSON.parse(data),i => i)
      }]
    })
  },
  getNsdConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModNextSurfacingDo>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/nextsurfacingdo/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModNextSurfacingDo>(JSON.parse(data),IrisrawModNextSurfacingDo.createIrisrawModNextSurfacingDo)
      }]
    })
  },
  saveNsdConfig(gliId:number,nsdConfig:IrisConfigContainer<INextSurfacingDoConfig>): AxiosPromise<AlrContainer<IrisrawModNextSurfacingDo>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/nextsurfacingdo/${gliId}/`, 
      method: 'PUT',
      data:nsdConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModNextSurfacingDo>(JSON.parse(data),IrisrawModNextSurfacingDo.createIrisrawModNextSurfacingDo)
      }]
    })
  },
  enableNsdModule(gliId:number,enable:boolean): AxiosPromise<AlrContainer<IrisrawModNextSurfacingDo>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/nextsurfacingdo/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{EnabledMOD:{'module-NextSurfacingDo':enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModNextSurfacingDo>(JSON.parse(data),IrisrawModNextSurfacingDo.createIrisrawModNextSurfacingDo)
      }]
    })
  },
  getFileTransfertConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModFileTransfer>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/filetransfer/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFileTransfer>(JSON.parse(data),IrisrawModFileTransfer.createIrisrawModFileTransfer)
      }]
    })
  },
  saveFileTransfertConfig(gliId:number,fileTransfertConfig:IrisConfigContainer<IFileTransfertConfig>): AxiosPromise<AlrContainer<IrisrawModFileTransfer>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/filetransfer/${gliId}/`, 
      method: 'PUT',
      data:fileTransfertConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFileTransfer>(JSON.parse(data),IrisrawModFileTransfer.createIrisrawModFileTransfer)
      }]
    })
  },
  enableFileTransfertModule(gliId:number,enable:boolean) {    
    return apiHelpers.apiCall({ 
      url: `api/iris/filetransfer/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{EnabledMOD:{'module-FileTransfer':enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFileTransfer>(JSON.parse(data),IrisrawModFileTransfer.createIrisrawModFileTransfer)
      }]
    })
  },
  getSingleWayPointConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModSingleWayPoint>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/singlewaypoint/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModSingleWayPoint>(JSON.parse(data),IrisrawModSingleWayPoint.createIrisrawModSingleWayPoint)
      }]
    })
  },
  saveSingleWayPointConfig(gliId:number,singleWayPointConfig:IrisConfigContainer<ISingleWayPointConfig>): AxiosPromise<AlrContainer<IrisrawModSingleWayPoint>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/singlewaypoint/${gliId}/`, 
      method: 'PUT',
      data:singleWayPointConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModSingleWayPoint>(JSON.parse(data),IrisrawModSingleWayPoint.createIrisrawModSingleWayPoint)
      }]
    })
  },
  enableSingleWayPointModule(gliId:number,enable:boolean) {   
    return apiHelpers.apiCall({ 
      url: `api/iris/singlewaypoint/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{EnabledMOD:{'module-SingleWayPoint':enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModSingleWayPoint>(JSON.parse(data),IrisrawModSingleWayPoint.createIrisrawModSingleWayPoint)
      }]
    })
  },
  getFtpConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModFtp>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/ftpconfig/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFtp>(JSON.parse(data),IrisrawModFtp.createIrisrawModFtp)
      }]
    })
  },
  saveFtpConfig(gliId:number,ftpConfig:IrisConfigContainer<IFtpConfig>): AxiosPromise<AlrContainer<IrisrawModFtp>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/ftpconfig/${gliId}/`, 
      method: 'PUT',
      data:ftpConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFtp>(JSON.parse(data),IrisrawModFtp.createIrisrawModFtp)
      }]
    })
  },
  enableFtpModule(gliId:number,enable:boolean) {   
    return apiHelpers.apiCall({ 
      url: `api/iris/ftpconfig/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{EnabledMOD:{'module-Ftp':enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModFtp>(JSON.parse(data),IrisrawModFtp.createIrisrawModFtp)
      }]
    })
  },
  getRsyncConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModRsync>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/rsyncconfig/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModRsync>(JSON.parse(data),IrisrawModRsync.createIrisrawModRsync)
      }]
    })
  },
  saveRsyncConfig(gliId:number,rsyncConfig:IrisConfigContainer<IRsyncConfig>): AxiosPromise<AlrContainer<IrisrawModRsync>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/rsyncconfig/${gliId}/`, 
      method: 'PUT',
      data:rsyncConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModRsync>(JSON.parse(data),IrisrawModRsync.createIrisrawModRsync)
      }]
    })
  },
  enableRsyncModule(gliId:number,enable:boolean) {   
    return apiHelpers.apiCall({ 
      url: `api/iris/rsyncconfig/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{EnabledMOD:{'module-Rsync':enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModRsync>(JSON.parse(data),IrisrawModRsync.createIrisrawModRsync)
      }]
    })
  },
  getExpectedNMEAConfig(gliId:number): AxiosPromise<AlrContainer<IrisrawModExpectedNMEA>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/expectednmea/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModExpectedNMEA>(JSON.parse(data),IrisrawModExpectedNMEA.createIrisrawModExpectedNMEA)
      }]
    })
  },
  saveExpectedNMEAConfig(gliId:number, expectedNMEAConfig:IrisConfigContainer<IExpectedNMEAConfig>): AxiosPromise<AlrContainer<IrisrawModExpectedNMEA>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/expectednmea/${gliId}/`, 
      method: 'PUT',
      data:expectedNMEAConfig,
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModExpectedNMEA>(JSON.parse(data),IrisrawModExpectedNMEA.createIrisrawModExpectedNMEA)
      }]
    })
  },
  enableExpectedNMEAModule(gliId:number, enable:boolean): AxiosPromise<AlrContainer<IrisrawModExpectedNMEA>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/expectednmea/${gliId}/`, 
      method: 'PUT',
      data: {mod_settings:{ExpectedNMEA:{auto_go:enable}}},
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawModExpectedNMEA>(JSON.parse(data),IrisrawModExpectedNMEA.createIrisrawModExpectedNMEA)
      }]
    })
  },
  getIrisGliderState(gliId:number): AxiosPromise<AlrContainer<IrisrawGliderState>> {    
    return apiHelpers.apiCall({ 
      url: `api/iris/gliderstate/${gliId}`, 
      method: 'GET',
      transformResponse: [function (data:string) {          
        return new AlrContainer<IrisrawGliderState>(JSON.parse(data),IrisrawGliderState.createIrisrawGliderState)
      }]
    })
  }
}